import { Star, Quote } from "lucide-react";
import { SectionTitle, Reveal } from "./Decor";

const Stars = ({ n = 5, className = "h-4 w-4" }) => (
  <div className="flex gap-0.5 text-yellow-400">
    {Array.from({ length: Math.max(0, Math.min(5, Number(n) || 0)) }).map((_, k) => (
      <Star key={k} className={`${className} fill-current`} />
    ))}
  </div>
);

export const ReviewsSection = ({ c, s }) => {
  const r = c?.reviews || {};
  const items = (r.items || []).filter((x) => x.text || x.name);
  const Pill = r.link ? "a" : "div";
  return (
    <section id="reviews" className="relative bg-white py-16 sm:py-20" data-testid="reviews-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <SectionTitle id="reviews" title={s.title} subtitle={s.subtitle} />
        {r.rating && (
          <Reveal className="-mt-4 mb-8">
            <Pill {...(r.link ? { href: r.link, target: "_blank", rel: "noopener noreferrer" } : {})} data-testid="reviews-rating" className="inline-flex flex-wrap items-center gap-3 rounded-full bg-yellow-50 px-5 py-3 ring-1 ring-yellow-100">
              <span className="font-display text-2xl font-semibold text-blue-900">{r.rating}</span>
              <Stars n={Math.round(Number(r.rating) || 5)} className="h-5 w-5" />
              {r.count && <span className="text-sm text-slate-600">{r.count} reviews{r.source ? ` on ${r.source}` : ""}</span>}
            </Pill>
          </Reveal>
        )}
        <div className="grid gap-5 md:grid-cols-2">
          {items.map((x, i) => (
            <Reveal key={x.id || i} delay={(i % 2) * 0.08}>
              <figure className="relative h-full rounded-[2rem] bg-sky-50 p-6 ring-1 ring-sky-100 transition-transform duration-300 hover:-translate-y-1" data-testid={`review-card-${i}`}>
                <Quote className="absolute right-6 top-6 h-8 w-8 text-sky-200" />
                <Stars n={x.rating || 5} />
                <blockquote className="mt-3 text-base leading-relaxed text-slate-700">{x.text}</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-pink-100 font-semibold text-pink-600">{(x.name || "?").trim().charAt(0).toUpperCase()}</span>
                  <div>
                    <p className="font-semibold text-blue-900">{x.name}</p>
                    {x.date && <p className="text-xs text-slate-500">{x.date}</p>}
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
